
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
declare var Chart: any;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartName: {
      type: String,
      default: ""
    },
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    legendName: {
      type: String,
      default: ""
    }
  },
  mounted() {
    var ctx = (document.getElementById(
      (this as any).chartName
    ) as any).getContext("2d");
    var chart = new Chart(ctx, {
      type: "doughnut",
      responsive: false,
      data: {
        labels: (this as any).chartData.labels,
        datasets: [
          {
            backgroundColor: (this as any).chartData.datasets.backgroundColor,
            data: (this as any).chartData.datasets.data
          }
        ]
      },
      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        animation: {
          animateRotate: false,
          animateScale: false
        },
        legend: {
          display: false
        },
        legendCallback: function(chart) {
          var text = [];
          text.push("<ul>");
          for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
            text.push(
              '<li><span style="background-color:' +
                chart.data.datasets[0].backgroundColor[i] +
                '">'
            );
            if (chart.data.labels[i]) {
              text.push(chart.data.labels[i]);
            }
            text.push("</span></li>");
          }
          text.push("</ul>");
          return text.join("");
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var label = data.labels[tooltipItem.index];
              var total = dataset.data.reduce(function(
                previousValue,
                currentValue,
                currentIndex,
                array
              ) {
                return previousValue + currentValue;
              });
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = Math.floor((currentValue / total) * 100 + 0.5);

              return label + ": " + percentage + "%";
            }
          }
        }
      }
    });

    var myLegendContainer = document.getElementById((this as any).legendName);
    myLegendContainer.innerHTML = chart.generateLegend();
  }
};
